import { render, staticRenderFns } from "./banser.vue?vue&type=template&id=301630d3&scoped=true&"
import script from "./banser.vue?vue&type=script&lang=js&"
export * from "./banser.vue?vue&type=script&lang=js&"
import style0 from "./banser.vue?vue&type=style&index=0&id=301630d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301630d3",
  null
  
)

export default component.exports